(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-contact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-contact')) {
    /* Zwischenspeicher fuer Felder, die Shopify nach einem Fehler nicht zurueckgibt */
    const STORAGE_KEY = 'pp-contact-draft';

    const readDraft = () => {
      try {
        const raw = window.sessionStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
      } catch (error) {
        return null;
      }
    };

    const writeDraft = (draft) => {
      try {
        window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(draft));
      } catch (error) {
        /* Speicher gesperrt (z. B. privater Modus): Formular funktioniert trotzdem */
      }
    };

    const clearDraft = () => {
      try {
        window.sessionStorage.removeItem(STORAGE_KEY);
      } catch (error) {
        /* ignorieren */
      }
    };

    class PpContact extends HTMLElement {
      connectedCallback() {
        this.topic = this.querySelector('[data-topic]');
        this.notice = this.querySelector('[data-withdrawal-notice]');
        this.order = this.querySelector('[data-order]');
        this.form = this.querySelector('form');

        const success = this.querySelector('[data-success]');
        if (success) {
          clearDraft();
          success.focus();
        }

        if (!this.topic) return;
        const wanted = new URLSearchParams(window.location.search).get('thema');
        if (wanted) {
          const option = this.topic.querySelector(`option[data-key="${CSS.escape(wanted)}"]`);
          if (option) this.topic.value = option.value;
        }

        /* Nur nach fehlgeschlagenem Absenden wiederherstellen, sonst alten Entwurf verwerfen */
        if (this.querySelector('[data-form-errors]')) {
          this.restoreDraft();
        } else {
          clearDraft();
        }

        this.update = this.update.bind(this);
        this.saveDraft = this.saveDraft.bind(this);
        this.topic.addEventListener('change', this.update);
        if (this.form) this.form.addEventListener('submit', this.saveDraft);
        this.update();
      }

      disconnectedCallback() {
        if (this.topic) this.topic.removeEventListener('change', this.update);
        if (this.form) this.form.removeEventListener('submit', this.saveDraft);
      }

      saveDraft() {
        const selected = this.topic.selectedOptions[0];
        writeDraft({
          topic: selected ? selected.dataset.key : '',
          order: this.order ? this.order.value : '',
        });
      }

      restoreDraft() {
        const draft = readDraft();
        if (!draft) return;
        if (draft.topic) {
          const option = this.topic.querySelector(`option[data-key="${CSS.escape(draft.topic)}"]`);
          if (option) this.topic.value = option.value;
        }
        if (this.order && typeof draft.order === 'string' && !this.order.value) {
          this.order.value = draft.order;
        }
      }

      update() {
        const selected = this.topic.selectedOptions[0];
        const isWithdrawal = selected && selected.dataset.key === 'widerruf';
        if (this.notice) this.notice.hidden = !isWithdrawal;
        if (this.order) this.order.required = Boolean(isWithdrawal);
      }
    }

    customElements.define('pp-contact', PpContact);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-faq-center"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-faq-center')) {
    const normalize = (value) =>
      (value || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');

    class PpFaqCenter extends HTMLElement {
      connectedCallback() {
        this.search = this.querySelector('[data-search]');
        this.items = Array.from(this.querySelectorAll('[data-item]'));
        this.groups = Array.from(this.querySelectorAll('[data-group]'));
        this.empty = this.querySelector('[data-empty]');
        /* Themen-Titel mit durchsuchen: "Rueckgabe" findet auch "Kann ich mein Geschenk zurueckgeben?" */
        this.index = this.items.map((item) => {
          const title = item.closest('[data-group]')?.querySelector('.pp-fc__group-title');
          return normalize(`${title ? title.textContent : ''} ${item.textContent}`);
        });

        if (this.search) this.search.addEventListener('input', this.filter);
        window.addEventListener('hashchange', this.openFromHash);
        this.openFromHash();
      }

      disconnectedCallback() {
        if (this.search) this.search.removeEventListener('input', this.filter);
        window.removeEventListener('hashchange', this.openFromHash);
      }

      openFromHash = () => {
        const id = window.location.hash.slice(1);
        if (!id.startsWith('faq-') || id.startsWith('faq-cat-')) return;
        const item = this.querySelector(`#${CSS.escape(id)}`);
        if (item && item.tagName === 'DETAILS') {
          item.open = true;
          item.scrollIntoView({ block: 'start' });
        }
      };

      filter = () => {
        const terms = normalize(this.search.value).split(/\s+/).filter(Boolean);
        let visible = 0;

        this.items.forEach((item, position) => {
          /* Lange Woerter auch ueber ihren Wortstamm finden: "Lieferzeit" trifft "Lieferung" und "liefert" */
          const match = terms.every(
            (term) => this.index[position].includes(term) || (term.length >= 8 && this.index[position].includes(term.slice(0, 6)))
          );
          item.hidden = !match;
          if (match) visible += 1;
          if (terms.length && match && visible <= 3) item.open = true;
          if (!terms.length) item.open = false;
        });

        this.groups.forEach((group) => {
          group.hidden = !group.querySelector('[data-item]:not([hidden])');
        });

        if (this.empty) this.empty.hidden = visible > 0;
      };
    }

    customElements.define('pp-faq-center', PpFaqCenter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-footer')) {
    class PpFooter extends HTMLElement {
      connectedCallback() {
        this.columns = Array.from(this.querySelectorAll('details[data-pp-footer-col]'));
        this.media = window.matchMedia('(min-width: 750px)');
        this.syncColumns = () => {
          const desktop = this.media.matches;
          this.columns.forEach((column) => {
            column.open = desktop;
            column.toggleAttribute('data-static', desktop);
          });
        };
        this.syncColumns();
        this.media.addEventListener('change', this.syncColumns);

        this.cookieButton = this.querySelector('[data-cookie-settings]');
        this.openCookieSettings = () => {
          const banner = window.privacyBanner;
          if (banner && typeof banner.showPreferences === 'function') {
            banner.showPreferences();
          } else if (this.cookieButton.dataset.fallbackUrl) {
            window.location.href = this.cookieButton.dataset.fallbackUrl;
          }
        };
        if (this.cookieButton) this.cookieButton.addEventListener('click', this.openCookieSettings);
      }

      disconnectedCallback() {
        if (this.media) this.media.removeEventListener('change', this.syncColumns);
        if (this.cookieButton) this.cookieButton.removeEventListener('click', this.openCookieSettings);
      }
    }

    customElements.define('pp-footer', PpFooter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-gift-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-gift-finder')) {
    const PAGES = [1, 2];
    const STEP_PARAMS = { recipient: 'fuer', occasion: 'anlass', product: 'produkt', budget: 'budget' };
    const poolCache = new Map();

    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    const priceFormatter = new Intl.NumberFormat('de-DE', { style: 'currency', currency });

    const parseData = (html) => {
      if (!html) return [];
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const script = doc.querySelector('script[data-pp-gift-data]');
      if (!script) return [];
      try {
        const data = JSON.parse(script.textContent);
        return Array.isArray(data) ? data : [];
      } catch (error) {
        return [];
      }
    };

    const loadPool = (url) => {
      if (!url) return Promise.resolve([]);
      if (!poolCache.has(url)) {
        const separator = url.includes('?') ? '&' : '?';
        const request = Promise.all(
          PAGES.map((page) =>
            fetch(`${url}${separator}section_id=pp-gift-data&page=${page}`, { credentials: 'same-origin' })
              .then((response) => (response.ok ? response.text() : ''))
              .then(parseData)
              .catch(() => [])
          )
        ).then((pages) => pages.flat());
        poolCache.set(url, request);
      }
      return poolCache.get(url);
    };

    class PpGiftFinder extends HTMLElement {
      connectedCallback() {
        this.steps = Array.from(this.querySelectorAll('[data-step]'));
        this.progress = this.querySelector('[data-progress]');
        this.count = this.querySelector('[data-count]');
        this.nav = this.querySelector('[data-nav]');
        this.backButton = this.querySelector('[data-back]');
        this.panel = this.querySelector('[data-results-panel]');
        this.grid = this.querySelector('[data-grid]');
        this.summary = this.querySelector('[data-summary]');
        this.note = this.querySelector('[data-note]');
        this.allLink = this.querySelector('[data-all]');
        this.answers = {};
        this.index = 0;
        /* Laufnummer der Ergebnissuche: nur der juengste Lauf darf rendern und melden */
        this.runId = 0;

        this.querySelectorAll('a[data-option]').forEach((link) => link.setAttribute('role', 'button'));
        this.addEventListener('click', this.handleClick);

        if (this.hasAttribute('data-deeplink') && this.applyDeepLink()) return;
        this.render(false);
      }

      disconnectedCallback() {
        this.runId += 1;
        this.removeEventListener('click', this.handleClick);
      }

      handleClick = (event) => {
        const option = event.target.closest('[data-option]');
        if (option && this.contains(option)) {
          event.preventDefault();
          this.choose(option);
          return;
        }
        if (event.target.closest('[data-back]')) {
          this.go(this.index - 1);
          return;
        }
        if (event.target.closest('[data-skip]')) {
          const step = this.steps[this.index];
          if (step) {
            delete this.answers[step.dataset.step];
            this.markSelected(step, null);
          }
          this.next();
          return;
        }
        if (event.target.closest('[data-restart]')) {
          this.answers = {};
          this.steps.forEach((step) => this.markSelected(step, null));
          this.updateUrl(true);
          this.go(0);
        }
      };

      readOption(option) {
        return {
          value: option.dataset.value,
          label: option.dataset.label,
          phrase: option.dataset.phrase || '',
          url: option.dataset.url || '',
          types: (option.dataset.types || '').split(',').map((type) => type.trim()).filter(Boolean),
          max: Number(option.dataset.max) || 0,
        };
      }

      choose(option) {
        const step = option.closest('[data-step]');
        this.answers[step.dataset.step] = this.readOption(option);
        this.markSelected(step, option);
        this.next();
      }

      markSelected(step, selected) {
        step.querySelectorAll('[data-option]').forEach((option) => {
          option.setAttribute('aria-pressed', option === selected ? 'true' : 'false');
        });
      }

      next() {
        if (this.index < this.steps.length - 1) {
          this.go(this.index + 1);
        } else {
          this.showResults();
        }
      }

      go(index) {
        /* Zurueck/Neustart verwirft eine noch laufende Ergebnissuche */
        this.runId += 1;
        this.index = Math.min(Math.max(index, 0), this.steps.length - 1);
        this.panel.hidden = true;
        this.render(true);
      }

      setProgress(ratio) {
        this.progress.parentElement.style.setProperty('--pp-gf-progress', `${Math.max(ratio * 100, 8)}%`);
      }

      render(moveFocus) {
        const total = this.steps.length;
        this.steps.forEach((step, stepIndex) => {
          step.hidden = stepIndex !== this.index;
        });
        this.nav.hidden = false;
        this.backButton.hidden = this.index === 0;
        this.count.textContent = (this.dataset.stepLabel || '')
          .replace('[current]', String(this.index + 1))
          .replace('[total]', String(total));
        this.setProgress((this.index + 1) / (total + 1));

        if (moveFocus) {
          const legend = this.steps[this.index] && this.steps[this.index].querySelector('.pp-gf__legend');
          if (legend) legend.focus({ preventScroll: true });
          this.scrollIntoViewIfNeeded();
        }
      }

      scrollIntoViewIfNeeded() {
        const rect = this.getBoundingClientRect();
        if (rect.top < 0 || rect.top > window.innerHeight * 0.5) {
          this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      applyDeepLink() {
        const params = new URLSearchParams(window.location.search);
        let applied = false;
        this.steps.forEach((step) => {
          const value = params.get(STEP_PARAMS[step.dataset.step]);
          if (!value) return;
          const option = step.querySelector(`[data-option][data-value="${CSS.escape(value)}"]`);
          if (!option) return;
          this.answers[step.dataset.step] = this.readOption(option);
          this.markSelected(step, option);
          applied = true;
        });
        if (!applied) return false;

        const firstOpen = this.steps.findIndex((step) => !this.answers[step.dataset.step]);
        if (firstOpen === -1) {
          this.showResults();
        } else {
          this.index = firstOpen;
          this.render(false);
        }
        return true;
      }

      updateUrl(clear) {
        if (!this.hasAttribute('data-deeplink')) return;
        const url = new URL(window.location.href);
        Object.values(STEP_PARAMS).forEach((param) => url.searchParams.delete(param));
        if (!clear) {
          Object.entries(this.answers).forEach(([step, answer]) => {
            if (STEP_PARAMS[step]) url.searchParams.set(STEP_PARAMS[step], answer.value);
          });
        }
        window.history.replaceState(window.history.state, '', url);
      }

      renderSkeleton(count) {
        this.grid.setAttribute('aria-busy', 'true');
        this.grid.replaceChildren(
          ...Array.from({ length: count }, () => {
            const item = document.createElement('li');
            item.className = 'pp-gf__skeleton';
            return item;
          })
        );
      }

      buildCard(product) {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.className = 'pp-gf__product pp-focus';
        link.href = product.u;

        const media = document.createElement('span');
        media.className = 'pp-product-media';
        if (product.i) {
          const image = document.createElement('img');
          image.src = product.i;
          image.alt = product.a || product.t;
          image.loading = 'lazy';
          image.decoding = 'async';
          image.width = 480;
          image.height = 480;
          media.append(image);
        }

        const title = document.createElement('span');
        title.className = 'pp-gf__title';
        title.textContent = product.t;

        const price = document.createElement('span');
        price.className = 'pp-gf__price';
        price.textContent = `${product.v ? 'ab ' : ''}${priceFormatter.format(product.p / 100)}`;

        link.append(media, title, price);
        item.append(link);
        return item;
      }

      rank(list) {
        return list.sort((a, b) => b.score - a.score || a.rank - b.rank);
      }

      async showResults() {
        const limit = Number(this.dataset.results) || 8;
        /* Momentaufnahme der Antworten, damit spaetere Klicks diesen Lauf nicht veraendern */
        const answers = { ...this.answers };
        const runId = ++this.runId;
        const isStale = () => runId !== this.runId;

        this.steps.forEach((step) => {
          step.hidden = true;
        });
        this.nav.hidden = true;
        this.panel.hidden = false;
        this.note.hidden = true;
        this.allLink.hidden = true;
        this.count.textContent = this.dataset.doneLabel || '';
        this.setProgress(1);

        const phrases = [answers.recipient, answers.occasion].filter(Boolean).map((answer) => answer.phrase).filter(Boolean);
        this.summary.textContent = phrases.length
          ? `${this.dataset.summaryPrefix || ''} ${phrases.join(' ')}`.trim()
          : this.dataset.summaryEmpty || '';
        this.renderSkeleton(limit);
        this.summary.focus({ preventScroll: true });
        this.scrollIntoViewIfNeeded();

        const sources = [
          [answers.recipient && answers.recipient.url, 3],
          [answers.occasion && answers.occasion.url, 3],
          [answers.product && answers.product.url, 2],
          [this.dataset.fallbackUrl, 0.5],
        ].filter(([url]) => url);

        const pools = await Promise.all(sources.map(([url]) => loadPool(url)));
        /* Veralteter Lauf (Neustart oder neuer Durchgang waehrend des Ladens): nichts anfassen.
           Die Anfragen selbst laufen weiter und fuellen den Cache fuer spaetere Laeufe. */
        if (isStale()) return;
        const products = new Map();
        pools.forEach((pool, poolIndex) => {
          const weight = sources[poolIndex][1];
          pool.forEach((product, position) => {
            const entry = products.get(product.id) || { ...product, score: 0, rank: Infinity };
            entry.score += weight;
            entry.rank = Math.min(entry.rank, position);
            products.set(product.id, entry);
          });
        });

        let candidates = Array.from(products.values());
        let relaxed = false;

        const budget = answers.budget && answers.budget.max ? answers.budget.max * 100 : 0;
        if (budget) {
          const withinBudget = candidates.filter((product) => product.p <= budget);
          if (withinBudget.length > 0) {
            candidates = withinBudget;
          } else {
            relaxed = true;
          }
        }

        const types = answers.product ? answers.product.types : [];
        let results;
        if (types.length > 0) {
          const matching = this.rank(candidates.filter((product) => types.includes(product.y)));
          const others = this.rank(candidates.filter((product) => !types.includes(product.y)));
          if (matching.length < Math.min(4, limit)) relaxed = true;
          results = matching.length >= Math.min(4, limit) ? matching : matching.concat(others);
        } else {
          results = this.rank(candidates);
        }
        results = results.slice(0, limit);

        this.grid.setAttribute('aria-busy', 'false');
        this.grid.replaceChildren(...results.map((product) => this.buildCard(product)));

        if (relaxed && this.dataset.relaxedText) {
          this.note.textContent = this.dataset.relaxedText;
          this.note.hidden = false;
        }

        const seeAll = answers.recipient || answers.occasion;
        if (seeAll && seeAll.url) {
          this.allLink.href = seeAll.url;
          this.allLink.textContent = `${this.dataset.allLabel || ''} ${seeAll.phrase || seeAll.label}`.trim();
          this.allLink.hidden = false;
        }

        this.updateUrl(false);

        const detail = {
          recipient: answers.recipient ? answers.recipient.value : null,
          occasion: answers.occasion ? answers.occasion.value : null,
          product: answers.product ? answers.product.value : null,
          budget: answers.budget ? answers.budget.value : null,
          results: results.length,
          relaxed,
        };
        this.dispatchEvent(new CustomEvent('pp:gift-finder:complete', { bubbles: true, detail }));
        try {
          if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
            window.Shopify.analytics.publish('pp_gift_finder_complete', detail);
          }
        } catch (error) {
          /* Analytics duerfen den Finder nie blockieren */
        }
      }
    }

    customElements.define('pp-gift-finder', PpGiftFinder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-gift-timeline"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-gift-timeline')) {
    class PpGiftTimeline extends HTMLElement {
      connectedCallback() {
        this.source = document.querySelector('delivery-estimate');
        if (!this.source) return;
        /* Der Liefer-Kern laedt asynchron (Modul): sonst auf 'pp:delivery-ready' warten */
        this.abortController = new AbortController();
        if (window.ppDelivery) this.start();
        else document.addEventListener('pp:delivery-ready', () => this.start(), { once: true, signal: this.abortController.signal });
      }

      start() {
        if (!this.isConnected || !window.ppDelivery) return;
        clearInterval(this.timer);
        this.config = window.ppDelivery.readConfig(this.source);
        this.update = this.update.bind(this);
        this.update();
        this.timer = setInterval(this.update, 60000);
      }

      disconnectedCallback() {
        if (this.abortController) this.abortController.abort();
        clearInterval(this.timer);
      }

      setText(slot, template, token, value) {
        const element = this.querySelector(`[data-slot="${slot}"]`);
        if (!element) return;
        if (!template || !token || !template.includes(token)) {
          element.textContent = template || value;
          return;
        }
        const [before, after] = template.split(token);
        const strong = document.createElement('strong');
        strong.textContent = value;
        element.replaceChildren(before, strong, after);
      }

      update() {
        const core = window.ppDelivery;
        const result = core.compute(this.config);
        const d = this.dataset;

        if (result.beforeCutoff) {
          this.setText('order', d.tplCountdown, '{countdown}', core.formatCountdown(result.minutesLeft));
        } else {
          this.setText('order', d.tplCutoff, '{hour}', `${this.config.cutoff} Uhr`);
        }
        this.setText('production', d.tplStart, '{date}', core.formatDate(result.productionStart));
        this.setText('ship', '', '', core.formatDate(result.shipDate));
        this.setText('delivery', '', '', core.formatRange(result.earliest, result.latest));
      }
    }

    customElements.define('pp-gift-timeline', PpGiftTimeline);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-hero-collage')) {
    class PpHeroCollage extends HTMLElement {
      connectedCallback() {
        const template = this.querySelector('template[data-pool]');
        this.list = this.querySelector('.pp-hero__collage');
        if (!template || !this.list || this.abortController) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        /* Warteschlange: Pool gemischt, damit jeder Besuch eine andere Abfolge sieht */
        this.queue = Array.from(template.content.children);
        if (!this.queue.length) return;
        for (let i = this.queue.length - 1; i > 0; i -= 1) {
          const j = Math.floor(Math.random() * (i + 1));
          [this.queue[i], this.queue[j]] = [this.queue[j], this.queue[i]];
        }

        this.interval = Math.max(Number(this.dataset.interval) || 3000, 2000);
        this.holds = new Set();
        this.lastSlot = -1;
        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.addEventListener('pointerenter', () => this.holds.add('hover'), { signal });
        this.addEventListener('pointerleave', () => this.holds.delete('hover'), { signal });
        this.addEventListener('focusin', () => this.holds.add('focus'), { signal });
        this.addEventListener('focusout', () => this.holds.delete('focus'), { signal });

        /* Mobile: waehrend und kurz nach dem Wischen im Streifen nichts austauschen */
        const holdForSwipe = () => {
          this.holds.add('swipe');
          clearTimeout(this.swipeTimer);
          this.swipeTimer = setTimeout(() => this.holds.delete('swipe'), 8000);
        };
        this.list.addEventListener('touchstart', holdForSwipe, { passive: true, signal });
        this.list.addEventListener('scroll', holdForSwipe, { passive: true, signal });

        const pauseButton = this.querySelector('[data-pause]');
        if (pauseButton) {
          const label = pauseButton.querySelector('[data-pause-label]');
          pauseButton.hidden = false;
          pauseButton.addEventListener(
            'click',
            () => {
              const paused = pauseButton.getAttribute('aria-pressed') !== 'true';
              pauseButton.setAttribute('aria-pressed', String(paused));
              if (label) label.textContent = paused ? 'Wechselnde Produkte fortsetzen' : 'Wechselnde Produkte anhalten';
              if (paused) this.holds.add('button');
              else this.holds.delete('button');
            },
            { signal }
          );
        }

        this.observer = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) this.holds.delete('offscreen');
          else this.holds.add('offscreen');
        });
        this.observer.observe(this);

        /* Erst nach dem Laden wechseln: die Pool-Bilder sollen nicht mit dem Seitenaufbau konkurrieren */
        const start = () => {
          this.timer = setInterval(() => this.tick(), this.interval);
        };
        if (document.readyState === 'complete') start();
        else window.addEventListener('load', start, { once: true, signal });
      }

      disconnectedCallback() {
        if (this.abortController) this.abortController.abort();
        this.abortController = null;
        if (this.observer) this.observer.disconnect();
        clearInterval(this.timer);
        clearTimeout(this.swipeTimer);
      }

      /* Naechste Kachel, deren Produkttyp noch nicht sichtbar ist (Abwechslung Karte, Tasse, Kissen ...) */
      takeNext(visibleTypes) {
        let index = this.queue.findIndex((item) => !visibleTypes.includes(item.dataset.type));
        if (index < 0) index = 0;
        return this.queue.splice(index, 1)[0];
      }

      async tick() {
        if (this.busy || this.holds.size || document.hidden || !this.queue.length) return;
        const slots = Array.from(this.list.children);
        if (!slots.length) return;

        let slot = Math.floor(Math.random() * slots.length);
        if (slot === this.lastSlot) slot = (slot + 1) % slots.length;
        this.lastSlot = slot;

        const current = slots[slot];
        const visibleTypes = slots.filter((item) => item !== current).map((item) => item.dataset.type);
        const incoming = document.importNode(this.takeNext(visibleTypes), true);

        this.busy = true;
        try {
          /* Bild vorladen, damit beim Einblenden nichts flackert */
          const image = incoming.querySelector('img');
          if (image) {
            image.loading = 'eager';
            await image.decode().catch(() => {});
          }
          if (this.holds.size || !current.isConnected) {
            this.queue.unshift(incoming);
            return;
          }
          /* Umklappen: alte Kachel dreht sich bis zur Kante weg, neue dreht sich von der anderen Seite herein */
          await current.animate(
            [{ transform: 'perspective(900px) rotateY(0deg)' }, { transform: 'perspective(900px) rotateY(90deg)' }],
            { duration: 260, easing: 'cubic-bezier(0.55, 0, 1, 0.45)' }
          ).finished;
          current.replaceWith(incoming);
          this.queue.push(current);
          await incoming.animate(
            [{ transform: 'perspective(900px) rotateY(-90deg)' }, { transform: 'perspective(900px) rotateY(0deg)' }],
            { duration: 340, easing: 'cubic-bezier(0, 0.55, 0.45, 1)' }
          ).finished;
        } finally {
          this.busy = false;
        }
      }
    }

    customElements.define('pp-hero-collage', PpHeroCollage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-marquee')) {
    class PpMarquee extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('.pp-mq__toggle');
        if (!this.toggle) return;
        this.onToggle = this.onToggle.bind(this);
        this.toggle.addEventListener('click', this.onToggle);
        /* Button erst mit JS zeigen, ohne JS pausiert das Band weiterhin bei Hover */
        this.toggle.hidden = false;
      }

      disconnectedCallback() {
        if (this.toggle) this.toggle.removeEventListener('click', this.onToggle);
      }

      onToggle() {
        const paused = this.toggle.getAttribute('aria-pressed') !== 'true';
        // Fester Name + aria-pressed (Toggle-Muster): "Laufband anhalten, gedrueckt" = pausiert
        this.toggle.setAttribute('aria-pressed', String(paused));
        this.toggleAttribute('data-paused', paused);
      }
    }

    customElements.define('pp-marquee', PpMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-motif-siblings"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-motif-siblings')) {
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    const priceFormatter = new Intl.NumberFormat('de-DE', { style: 'currency', currency });

    const fetchProducts = async (url) => {
      if (!url) return [];
      try {
        const response = await fetch(`${url}?section_id=pp-gift-data`, { credentials: 'same-origin' });
        if (!response.ok) return [];
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const script = doc.querySelector('script[data-pp-gift-data]');
        const data = script ? JSON.parse(script.textContent) : [];
        return Array.isArray(data) ? data : [];
      } catch (error) {
        return [];
      }
    };

    class PpMotifSiblings extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('[data-grid]');
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              if (entries.some((entry) => entry.isIntersecting)) {
                this.observer.disconnect();
                this.load();
              }
            },
            { rootMargin: '400px 0px' }
          );
          this.observer.observe(this);
        } else {
          this.load();
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      hide() {
        const wrapper = this.closest('.shopify-section') || this;
        wrapper.hidden = true;
      }

      select(products) {
        const currentId = Number(this.dataset.productId);
        const max = Number(this.dataset.max) || 4;
        const candidates = products.filter((product) => product.id !== currentId);
        const seenTypes = new Set();
        const distinct = [];
        const rest = [];
        candidates.forEach((product) => {
          if (!seenTypes.has(product.y)) {
            seenTypes.add(product.y);
            distinct.push(product);
          } else {
            rest.push(product);
          }
        });
        return distinct.concat(rest).slice(0, max);
      }

      async load() {
        const min = Number(this.dataset.min) || 2;
        let selection = this.select(await fetchProducts(this.dataset.url));

        if (selection.length < min && this.dataset.worldUrl) {
          const worldSelection = this.select(await fetchProducts(this.dataset.worldUrl));
          if (worldSelection.length > selection.length) {
            selection = worldSelection;
            const heading = this.querySelector('[data-heading]');
            const subheading = this.querySelector('[data-subheading]');
            const worldLink = this.querySelector('[data-world-link]');
            if (heading && this.dataset.worldHeading) heading.textContent = this.dataset.worldHeading;
            if (subheading) subheading.textContent = this.dataset.worldSubheading || '';
            if (worldLink) worldLink.hidden = false;
          }
        }

        if (selection.length === 0) {
          this.hide();
          return;
        }

        this.grid.setAttribute('aria-busy', 'false');
        this.grid.replaceChildren(...selection.map((product) => this.buildCard(product)));
      }

      buildCard(product) {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.className = 'pp-sib__card pp-focus';
        link.href = product.u;

        const media = document.createElement('span');
        media.className = 'pp-product-media';
        if (product.i) {
          const image = document.createElement('img');
          image.src = product.i;
          image.alt = product.a || product.t;
          image.loading = 'lazy';
          image.decoding = 'async';
          image.width = 480;
          image.height = 480;
          media.append(image);
        }
        link.append(media);

        if (product.y) {
          const type = document.createElement('span');
          type.className = 'pp-sib__type';
          type.textContent = product.y;
          link.append(type);
        }

        const title = document.createElement('span');
        title.className = 'pp-sib__title';
        title.textContent = product.t;

        const price = document.createElement('span');
        price.className = 'pp-sib__price';
        price.textContent = `${product.v ? 'ab ' : ''}${priceFormatter.format(product.p / 100)}`;

        link.append(title, price);
        item.append(link);
        return item;
      }
    }

    customElements.define('pp-motif-siblings', PpMotifSiblings);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-occasions"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-occasions')) {
    const DAY_MS = 86400000;
    const todayFormatter = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit' });
    const labelFormatter = new Intl.DateTimeFormat('de-DE', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'long' });

    const toUtc = (iso) => {
      const [year, month, day] = iso.split('-').map(Number);
      return Date.UTC(year, month - 1, day);
    };

    class PpOccasions extends HTMLElement {
      /* Der Liefer-Kern (Anlass-Kalender) laedt asynchron als Modul: sonst auf 'pp:delivery-ready' warten */
      connectedCallback() {
        this.abortController = new AbortController();
        if (window.ppDelivery) this.render();
        else document.addEventListener('pp:delivery-ready', () => this.render(), { once: true, signal: this.abortController.signal });
      }

      disconnectedCallback() {
        if (this.abortController) this.abortController.abort();
      }

      render() {
        const list = this.querySelector('[data-list]');
        if (!list || !this.isConnected) return;
        const today = toUtc(todayFormatter.format(new Date()));
        const max = Number(this.dataset.max) || 5;
        const urgentDays = Number(this.dataset.urgentDays) || 21;
        const items = Array.from(list.children);

        const core = window.ppDelivery;
        const todayDate = new Date(today);

        /* Eigenes Datum: jaehrlich wiederkehrend (JJJJ-MM-TT oder MM-TT) */
        const nextYearly = (value) => {
          const match = /^(?:\d{4}-)?(\d{2})-(\d{2})$/.exec(value || '');
          if (!match) return null;
          const year = todayDate.getUTCFullYear();
          let date = Date.UTC(year, Number(match[1]) - 1, Number(match[2]));
          if (date < today) date = Date.UTC(year + 1, Number(match[1]) - 1, Number(match[2]));
          return new Date(date).toISOString().slice(0, 10);
        };

        const entries = items.map((item) => {
          const rule = item.dataset.rule || 'auto';
          let iso = '';
          if (rule !== 'none') {
            let query = rule;
            if (rule === 'auto') query = item.dataset.title;
            if (rule === 'date') query = '';
            const occasion = core && core.findOccasion ? core.findOccasion(query) : null;
            iso = occasion ? core.nextOccasionDate(occasion, todayDate).toISOString().slice(0, 10) : nextYearly(item.dataset.date) || '';
          }
          const valid = /^\d{4}-\d{2}-\d{2}$/.test(iso);
          const days = valid ? Math.round((toUtc(iso) - today) / DAY_MS) : null;
          return { item, iso, valid, days };
        });

        entries.forEach((entry) => {
          const { item, valid, days, iso } = entry;
          if (!valid) return;
          if (days < 0) {
            item.hidden = true;
            return;
          }
          const dateLabel = item.querySelector('[data-date-label]');
          if (dateLabel) dateLabel.textContent = labelFormatter.format(new Date(toUtc(iso)));
          const badge = item.querySelector('[data-badge]');
          if (badge) {
            badge.textContent = days === 0 ? 'Heute' : days === 1 ? 'Morgen' : `noch ${days} Tage`;
            badge.toggleAttribute('data-urgent', days <= urgentDays);
            badge.hidden = false;
          }
        });

        const visible = entries
          .filter((entry) => !entry.item.hidden)
          .sort((a, b) => {
            if (a.valid && b.valid) return a.days - b.days;
            if (a.valid) return -1;
            if (b.valid) return 1;
            return 0;
          });

        visible.forEach((entry, index) => {
          entry.item.hidden = index >= max;
          list.append(entry.item);
        });
      }
    }

    customElements.define('pp-occasions', PpOccasions);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-reviews')) {
    class PpReviews extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-more-button]');
        if (this.button) this.button.addEventListener('click', this.showMore);
      }

      disconnectedCallback() {
        if (this.button) this.button.removeEventListener('click', this.showMore);
      }

      showMore = () => {
        const size = Number(this.dataset.pageSize) || 12;
        const hidden = Array.from(this.querySelectorAll('[data-more][hidden]'));
        hidden.slice(0, size).forEach((item) => {
          item.hidden = false;
        });
        if (hidden.length <= size) this.button.hidden = true;
      };
    }

    customElements.define('pp-reviews', PpReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-tracking"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-tracking-form')) {
    class PpTrackingForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-tracking-form]');
        this.error = this.querySelector('[data-error]');
        if (this.form) this.form.addEventListener('submit', this.handleSubmit);
      }

      disconnectedCallback() {
        if (this.form) this.form.removeEventListener('submit', this.handleSubmit);
      }

      handleSubmit = (event) => {
        event.preventDefault();
        const number = (this.form.elements.tracking.value || '').replace(/\s+/g, '').trim();
        const template = this.form.elements.carrier ? this.form.elements.carrier.value : '';

        if (number.length < 6 || !template.includes('{nummer}')) {
          this.error.hidden = false;
          this.form.elements.tracking.setAttribute('aria-invalid', 'true');
          this.form.elements.tracking.focus();
          return;
        }

        this.error.hidden = true;
        this.form.elements.tracking.removeAttribute('aria-invalid');
        window.open(template.replace('{nummer}', encodeURIComponent(number)), '_blank', 'noopener');
      };
    }

    customElements.define('pp-tracking-form', PpTrackingForm);
  }

  } catch(e) { console.error(e); }
})();
})();
